import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Output, EventEmitter } from "@angular/core"; import { Location } from "@angular/common";

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { ItemMin } from '../entites/item-min';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { Item } from '../entites/item';
import { BonCommandeEntite } from '../entites/bon-commande';
import { Statut } from '../entites/statut';
import { CategorieMin, CategorieEntite } from '../entites/categorie';
import { SousCategorieEntite } from '../entites/sousCategorie';
import { Emplacement } from '../entites/emplacement';
import { AttributEntite } from '../entites/attribut';
import { EmployeEntite } from '../entites/employe';
import { EmplacementService } from './emplacement-service';
import { DonneesBaseService } from './donnees-base-service';
import { FavoriEntite } from '../entites/favori';
import { HistoriqueEntite } from '../entites/historique';
import { RapportEntite } from '../entites/rapport';
import { ProfilEntite } from '../entites/profil';
import { BaseService } from './base.service';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class ProfilService extends BaseService {

  @Output() changementFavoris = new EventEmitter<FavoriEntite[]>();
  @Output() changementHistorique = new EventEmitter<HistoriqueEntite[]>();

  private employeConnecte: EmployeEntite;

  private favoris: FavoriEntite[] = null;

  private historiques: HistoriqueEntite[] = [];



  private obtenirFavorisUrl = environment.apiBaseUrl + 'profil/{employeId}/favoris';
  private ajouterFavorisUrl = environment.apiBaseUrl + 'profil/favori';
  private supprimerFavorisUrl = environment.apiBaseUrl + 'profil/favori/{favoriId}';
  private obtenirProfilUrl = environment.apiBaseUrl + 'profil';
  private impersonerEmployeUrl = environment.apiBaseUrl + 'profil/impersonate/{employeId}';
  private arreterImpersonationUrl = environment.apiBaseUrl + 'profil/stop-impersonation';

  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  private _profil: ProfilEntite;

  constructor(
    public messageService: MessageService,
    public sdb: DonneesBaseService,
    private http: HttpClient,
    public router: Router) { 
      super(messageService, router);
    }

  public ProfilCourant(): EmployeEntite {
    return this._profil.employe;
  }

  public Profil(): ProfilEntite {
    return this._profil;
  }

  public estAutoriseTache(code: string): boolean {
    if (!this._profil){
      return false;
    }

    return this._profil.taches.filter(x => x.code == code).length > 0;
  }

  /// <summary>
  /// Obtient le profil de l'utilisateur connecté depuis l'API
  /// </summary>
  /// <returns>Observable contenant le profil utilisateur</returns>
  public ObtenirProfil(): Observable<ProfilEntite> {
    return this.http.get<ProfilEntite>(this.obtenirProfilUrl)
    .pipe(
      tap(x => this._profil = x),
      catchError(error => this.handleError(error))
    );
  }


  public ObtenirFavoris(employeId: number): Promise<FavoriEntite[]> {
    return new Promise<FavoriEntite[]>(resolve => {
      if (this.favoris != null) {
        resolve(this.favoris);
      } else {
        this.http.get<ReponseBase<FavoriEntite[]>>(this.obtenirFavorisUrl.replace('{employeId}', employeId.toString())).toPromise().then(res => {
          this.favoris = res.valeur;
          resolve(this.favoris);
        });
      }
    });
  }

  public rafraichirFavoris(employeId: number) {
    this.favoris = null;
    this.ObtenirFavoris(employeId).then(x => {
      this.changementFavoris.emit(this.favoris);
    });
  }

  public ajouterFavori(requete: FavoriEntite): Promise<ReponseBase<FavoriEntite>> {
    var p = this.http.post<ReponseBase<FavoriEntite>>(this.ajouterFavorisUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public supprimerFavori(favoriId: number) {

    this.http.delete<ReponseBase<boolean>>(this.supprimerFavorisUrl.replace('{favoriId}', favoriId.toString())).toPromise().then(x => {
      this.favoris = this.favoris.filter(x => x.favoriId != favoriId);
      this.changementFavoris.emit(this.favoris);
    });

    //var p = this.http.delete<ReponseBase<boolean>>(this.supprimerFavorisUrl.replace('{favoriId}', favoriId.toString())).toPromise();
  }

  public verifierFavori(employeId: number, url: string): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      if (this.favoris != null) {
        resolve(this.favoris.filter(x => x.url == url).length > 0);
      } else {
        this.http.get<ReponseBase<FavoriEntite[]>>(this.obtenirFavorisUrl.replace('{employeId}', employeId.toString())).toPromise().then(res => {
          this.favoris = res.valeur;
          resolve(this.favoris.filter(x => x.url == url).length > 0);
        });
      }
    });
  }

  public obtenirHistorique() {
    return this.historiques;
  }

  public ajouterHistorique(requete: HistoriqueEntite) {
    this.historiques = this.historiques.filter(x => x.url != requete.url);
    this.historiques.unshift(requete);
    this.historiques = this.historiques.slice(0, 10);
    this.changementHistorique.emit(this.historiques);
  }

  public viderHistorique() {
    this.historiques = [];
    this.changementHistorique.emit(this.historiques);
  }

  /// <summary>
  /// Impersonne les rôles d'un employé
  /// </summary>
  /// <param name="employeId">ID de l'employé à impersonner</param>
  /// <returns>Observable contenant le résultat de l'opération</returns>
  public ImpersonerEmploye(employeId: number): Observable<any> {
    const url = this.impersonerEmployeUrl.replace('{employeId}', employeId.toString());
    return this.http.post<any>(url, {}, this.httpOptions)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  /// <summary>
  /// Arrête le mode imitation et restaure les rôles normaux
  /// </summary>
  /// <returns>Observable contenant le résultat de l'opération</returns>
  public ArreterImpersonation(): Observable<any> {
    return this.http.post<any>(this.arreterImpersonationUrl, {}, this.httpOptions)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  /// <summary>
  /// Vérifie si l'utilisateur est actuellement en mode imitation
  /// </summary>
  /// <returns>True si en mode imitation, false sinon</returns>
  public EstEnModeImitation(): boolean {
    return this._profil?.indModeImitation === true;
  }
}
